
import { StoreApi } from 'zustand';
import { PriceAlert } from '@/types/price';
import { PriceState } from '../../types';
import { UserState } from '../../../auth/userSlice';
import { priceAlertService } from '@/services/priceAlerts/priceAlertService';

type GetPriceState = () => PriceState & UserState;
type SetPriceState = StoreApi<PriceState & UserState>["setState"];

export const createPriceAlert = async (
  set: SetPriceState,
  get: GetPriceState,
  alert: Omit<PriceAlert, 'id' | 'userId'>
): Promise<PriceAlert> => {
  try {
    const state = get();
    const { user, isAuthenticated } = state;
    
    if (!isAuthenticated || !user) {
      console.error('[createPriceAlert] User not authenticated');
      throw new Error('Utente non autenticato');
    }
    
    if (!user.id) {
      console.error('[createPriceAlert] Missing user ID');
      throw new Error('ID utente mancante');
    }
    
    // Crea l'avviso utilizzando il servizio separato (non-bloccante)
    const newAlert = await priceAlertService.createAlert({
      ...alert,
      userId: user.id,
      isActive: true,
    });

    // Aggiorna lo store immediatamente
    set((state: PriceState & UserState) => ({
      priceAlerts: [...state.priceAlerts, newAlert]
    }));
    
    // Richiesta permessi notifiche in background (non-bloccante)
    priceAlertService.requestNotificationPermissionAsync().then(granted => {
      // Permission handled silently
    }).catch(error => {
      console.warn('[createPriceAlert] Permission request background error:', error);
    });
    
    return newAlert;
  } catch (error) {
    console.error('[createPriceAlert] Error creating price alert:', error);
    throw error;
  }
};
